<div class="delivery-etd-container">
  <!-- input area -->
  <div class="input-area" outsideClick (clickOutside)="closeSavedAddressPanel()">
    <div class="input-area-content">
      <div class="d-flex align-items-center">
        <!-- desktop  -->
        <input
          class="d-none d-sm-none d-md-none d-lg-block d-xl-block d-xxl-block"
          placeholder="Enter delivery pincode"
          [formControl]="deliveryPincode"
          maxlength="6"
          (click)="openSavedAddressPanel()"
          (keydown)="openSavedAddressPanel()"
          (keydown.enter)="expectedDeliveryForPincode()"
          (focusout)="focusOutEvent()"
        />

        <!-- mobile first -->
        <input
          class="d-block d-sm-block d-md-block d-lg-none d-xl-none d-xxl-none"
          placeholder="Enter delivery pincode"
          [formControl]="deliveryPincode"
          type="number"
          maxlength="6"
          (keydown)="unPatchAddress()"
          (keyup)="expectedDeliveryForPincode()"
          (focusout)="focusOutEvent()"
        />

        <!-- desktop  -->
        @if (openAddressPanel) {
          <span
            (click)="expectedDeliveryForPincode()"
            class="action d-none d-sm-none d-md-none d-lg-block d-xl-block d-xxl-block"
            >Check</span
          >
        }
        @if (!openAddressPanel) {
          <span
            class="action d-none d-sm-none d-md-none d-lg-block d-xl-block d-xxl-block"
            (click)="toggleSavedAddressPanel(); $event.stopPropagation()"
            >Change</span
          >
        }

        <!-- mobile first -->
        <span
          class="action d-block d-sm-block d-md-block d-lg-none d-xl-none d-xxl-none"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasBottom"
          aria-controls="offcanvasBottom"
          >Change</span
        >
      </div>
    </div>

    <!-- desktop  -->
    @if (openAddressPanel) {
      <section class="addressess-section d-none d-sm-none d-md-none d-lg-block d-xl-block d-xxl-block" @slideDownEasy>
        <div class="d-flex align-items-center justify-content-between address-heading">
          <h2>Saved addresses</h2>
          @if (noAddressesCreated) {
            <span class="add-address-btn" (click)="navigateToCreateAdress()"> +ADD</span>
          }
        </div>

        <!-- address section empty state for desktop -->
        @if (!user()) {
          <div class="d-flex align-items-center justify-content-center address-empty-state">
            <img
              class="hero-image"
              src="https://assets.hyperinvento.com/hyperinventory_admin/assets/images/core/login-hero-dark.svg"
            />
            <div>
              <p class="caption">Log in to view saved addresses</p>
              <div>
                <span class="action-link" (click)="navigateToLogin()">Log in</span>
              </div>
            </div>
          </div>
        }
        @if (addresses$ | async; as addresses) {
          @if (!noAddressesCreated) {
            <ul class="address-list-desktop">
              @for (address of addresses; track address.id) {
                <li (click)="patchPincode(address.pincode || '')">
                  <span>{{ address.pincode }}</span>
                  {{ address | completeAddressConcat }}
                </li>
              }
            </ul>
          }
        }
      </section>
    }
  </div>

  <!-- error msg -->
  @if (deliveryPincode.invalid && (deliveryPincode.touched || deliveryPincode.dirty)) {
    <p class="error-msg">Not a valid pincode</p>
  }
  @if (errorMessage && deliveryPincode.valid && !loading) {
    <p class="error-msg">
      {{ errorMessage }}
    </p>
  }

  <!-- etd info -->
  @if (expectedDeliveryDates$ | async; as expectedDeliveryDates) {
    @if (expectedDeliveryDates?.estimated_days_for_delivery?.fastest_delivery_by && deliveryPincode.valid) {
      <div class="delivery-etd-info" (click)="aboutDeliveryPanel(); $event.stopPropagation()">
        Expected Delivery by
        <span class="date-info">
          {{ expectedDeliveryDates.estimated_days_for_delivery?.fastest_delivery_by | date: 'd LLL' }},
          {{ expectedDeliveryDates.estimated_days_for_delivery?.fastest_delivery_by | date: 'EEEE' }}</span
        >

        @if (
          expectedDeliveryDates.estimated_days_for_delivery?.slowest_delivery_by !==
          expectedDeliveryDates.estimated_days_for_delivery?.fastest_delivery_by
        ) {
          <span class="date-info">
            to
            {{ expectedDeliveryDates.estimated_days_for_delivery?.slowest_delivery_by | date: 'd LLL' }},
            {{ expectedDeliveryDates.estimated_days_for_delivery?.slowest_delivery_by | date: 'EEEE' }}
          </span>
        }
        <div class="about-delivery-etd">
          <p>
            The actual delivery date of your package may take 1 or 2 days longer than initially estimated due to reasons
            as holidays or delay from third party logistic companies.
          </p>
        </div>
      </div>
    }
  }
  @if (loading) {
    <custom-shimmer [_repeat]="1" [multiStrokeWithImage]="false" [singleStroke]="true"></custom-shimmer>
  }
</div>

<!-- Bottom sheet -->
<div
  class="offcanvas offcanvas-bottom"
  tabindex="-1"
  id="offcanvasBottom"
  aria-labelledby="offcanvasBottomLabel"
  #offcanvas
>
  @if (addresses$ | async; as addresses) {
    <div class="offcanvas-header">
      <h5>Select from saved addresses</h5>

      <!-- close btn -->
      <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" #offcanvasClose></button>
    </div>

    <div class="offcanvas-body small">
      <!-- saved addresses -->
      @if (!noAddressesCreated) {
        @for (address of addresses; track address.id; let i = $index) {
          <div
            class="address-card mb-3"
            (click)="patchPincodeForMobile(address.pincode || '', i)"
            [ngClass]="{ 'address-selected': i === selectedAddressIndex }"
          >
            <div class="address-badge">
              <span>{{ address?.tag }}</span>
            </div>
            <p>{{ address?.pincode }} {{ address | completeAddressConcat }}</p>
          </div>
        }
      } @else {
        <div class="d-flex flex-column align-items-center justify-content-center text-center no-address-card">
          <img
            class="hero-image"
            src="https://assets.hyperinvento.com/hyperinventory_admin/assets/images/core/location-hero-dark.svg"
          />
          <div>
            <p class="caption">No Address found please add delivery address</p>
            <span class="action-link" (click)="navigateToCreateAdress()">+ Add address</span>
          </div>
        </div>
      }
    </div>
  }

  <!-- if not logged in -->
  @if (!user()) {
    <div class="offcanvas-header">
      <h5>Select from saved addresses</h5>

      <!-- close btn -->
      <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" #offcanvasClose></button>
    </div>
    <div class="offcanvas-body small">
      <div class="d-flex flex-column align-items-center justify-content-center text-center empty-address-card">
        <img
          class="hero-image"
          src="https://assets.hyperinvento.com/hyperinventory_admin/assets/images/core/login-hero-dark.svg"
        />
        <div>
          <p class="caption">Please log in to view saved addresses</p>
          <span class="action-link" (click)="navigateToLogin()">Log in</span>
        </div>
      </div>
    </div>
  }
</div>
